import { MapGeneratedEntity } from "./generated/MapGeneratedEntity";

export abstract class MapEntity extends MapGeneratedEntity {
    /**
     * Returns the name of the map without its file extension.
     */
    public get nameComputed(): string {
        return this.filename?.replace(/\.[^/.]+$/, "") ?? "";
    }
}
